import PropTypes from 'prop-types'

const MySeparatorForm = ({ text, initial }) => {
  return (
    <div
      className={`${
        !initial ? 'mb-4 mt-6' : 'my-4'
      } relative flex items-center justify-center`}
    >
      <div className="h-[1px] w-full bg-gray-300" />
      <span className="absolute bg-white px-2 text-sm capitalize text-gray-500">
        {text}
      </span>
    </div>
  )
}

export default MySeparatorForm

MySeparatorForm.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  initial: PropTypes.bool,
}
